(() => {
  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const visible = (el) => {
    if (!(el instanceof HTMLElement)) return false;
    const st = getComputedStyle(el);
    if (st.display === 'none' || st.visibility === 'hidden') return false;
    const r = el.getBoundingClientRect();
    return r.width > 80 && r.height > 40;
  };

  const findHeading = () =>
    [...document.querySelectorAll('h1,h2,h3')]
      .filter(visible)
      .find((el) => norm(el.textContent) === 'frequently asked questions');

  const findSection = (heading) => {
    let node = heading;
    while (node && node !== document.body) {
      if (node.matches?.('section')) return node;
      node = node.parentElement;
    }
    return heading.closest('.shopify-section') || heading.parentElement;
  };

  const findCopyColumn = (section, heading) => {
    let node = heading.parentElement;
    let candidate = heading.parentElement;
    while (node && node !== section) {
      const r = node.getBoundingClientRect();
      if (r.width > 300 && r.height > 250) candidate = node;
      node = node.parentElement;
    }
    return candidate;
  };

  const findMediaImage = (section, heading) => {
    const headingRect = heading.getBoundingClientRect();
    const imgs = [...section.querySelectorAll('img')]
      .filter(visible)
      .filter((img) => {
        const r = img.getBoundingClientRect();
        return r.width > 280 && r.height > 280 && r.left > headingRect.left + headingRect.width * 0.45;
      })
      .sort((a, b) => {
        const ar = a.getBoundingClientRect();
        const br = b.getBoundingClientRect();
        return (br.width * br.height) - (ar.width * ar.height);
      });

    return imgs[0] || null;
  };

  const findMediaContainer = (img, section) => {
    let node = img.parentElement;
    let candidate = img.parentElement;

    while (node && node !== section) {
      const r = node.getBoundingClientRect();
      const sr = section.getBoundingClientRect();

      if (r.width >= sr.width * 0.30 && r.height >= 250) {
        candidate = node;
      }
      node = node.parentElement;
    }
    return candidate;
  };

  const findGrid = (heading, mediaContainer, section) => {
    const headingAncestors = [];
    let node = heading;
    while (node && node !== section) {
      headingAncestors.push(node);
      node = node.parentElement;
    }

    let m = mediaContainer;
    while (m && m !== section) {
      if (headingAncestors.includes(m.parentElement)) return m.parentElement;
      m = m.parentElement;
    }
    return null;
  };

  const firstOpaqueBg = (el) => {
    let node = el;
    while (node && node !== document.documentElement) {
      const bg = getComputedStyle(node).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
      node = node.parentElement;
    }
    return 'rgb(247, 245, 239)';
  };

  const apply = () => {
    const heading = findHeading();
    if (!heading) return;

    const section = findSection(heading);
    if (!section) return;

    const copy = findCopyColumn(section, heading);
    const img = findMediaImage(section, heading);
    if (!img) return;

    const mediaContainer = findMediaContainer(img, section);
    const grid = mediaContainer ? findGrid(heading, mediaContainer, section) : null;

    section.classList.add('elizna-faq-bgmatch-v1');
    if (grid) grid.classList.add('elizna-faq-bgmatch-v1__grid');
    if (copy) copy.classList.add('elizna-faq-bgmatch-v1__copy');
    if (mediaContainer) mediaContainer.classList.add('elizna-faq-bgmatch-v1__media');

    const bg = firstOpaqueBg(copy || section);
    section.style.setProperty('--elizna-faq-bgmatch-bg', bg);
  };

  const schedule = () => requestAnimationFrame(apply);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
})();
